module.exports = __webpack_public_path__ + "img/yyzz-photo.45e60389.png";